<!-- Modal Container with content projection for child components -->
<div
  #modalContainer
  (click)="onModalClick($event)"
  [class.paused]="!isPlaying()"
  [class.playing]="isPlaying()"
  class="slideshow-modal">

  <!-- Content projection for child components -->
  <ng-content></ng-content>
</div>
